import {
  EmployeeProfileForm,
  EmployeeProfileFormValidation,
  ErrorField,
  MerchantProfileForm,
  MerchantProfileFormValidation,
  MerchantOTPRequiredFields,
  MerchantProfileFields,
  EmployeeOTPRequiredFields,
  EmployeeProfileFields,
} from "../utils/form-fields";
import {
  DEFAULT_COUNTRY_CODE,
  EMAIL_IS_INVALID,
  EMAIL_REGEX,
  NUMBER_INPUT_REGEX,
  ONLY_CHARACTERS_NUMBERS_AND_SPACES_REGEX,
  PHONE_NUMBER_IS_INVALID,
} from "@zenith/data/constants";
import { getPhoneNumberLength } from "@zenith/features/globalUtils";
import { KeyboardEvent } from "react";

export const NO_ERROR = {
  message: "",
  hasError: false,
};

export const validatePhoneNumber = (value: string): ErrorField => {
  if (!value) {
    return {
      message: "Phone number is required",
      hasError: true,
    };
  }
  if (value.length < getPhoneNumberLength(DEFAULT_COUNTRY_CODE, value)) {
    return {
      message: PHONE_NUMBER_IS_INVALID,
      hasError: true,
    };
  }
  return NO_ERROR;
};

export const validateEmployeeEmail = (value: string): ErrorField => {
  if (value && !EMAIL_REGEX.test(value)) {
    return {
      message: EMAIL_IS_INVALID,
      hasError: true,
    };
  }

  return NO_ERROR;
};

export const validateMerchantEmail = (
  value: string,
  userEmail: string
): ErrorField => {
  if (userEmail && !value) {
    return {
      message: "Email address is required",
      hasError: true,
    };
  }

  if (value && !EMAIL_REGEX.test(value)) {
    return {
      message: EMAIL_IS_INVALID,
      hasError: true,
    };
  }

  return NO_ERROR;
};

export const validateTradingName = (value: string): ErrorField => {
  if (!value) {
    return {
      message: "Trading name is required",
      hasError: true,
    };
  }
  return NO_ERROR;
};

export const preventSpace = (event: KeyboardEvent<HTMLInputElement>) => {
  const key = event.key;
  if (/\s+/g.test(key)) {
    return event.preventDefault();
  }
};

export const processValue = (
  field: MerchantProfileFields | EmployeeProfileFields,
  value: string
) => {
  switch (field) {
    case MerchantProfileFields.PHONE_NUMBER:
    case EmployeeProfileFields.PHONE_NUMBER:
      return value.replace(NUMBER_INPUT_REGEX, "");
    case MerchantProfileFields.EMAIL:
    case EmployeeProfileFields.EMAIL:
      return value.split(" ").join("");
    default:
      return value;
  }
};

export const merchantFormHasError = (
  formErrors: MerchantProfileFormValidation
) => {
  return Object.values(formErrors).some((error) => error.hasError);
};

export const hasMerchantFormChanged = (
  formData: MerchantProfileForm,
  defaultFormData: MerchantProfileForm
) => {
  return Object.keys(formData).some((k) => {
    const key = k as keyof MerchantProfileForm;
    return formData[key] !== defaultFormData[key];
  });
};

export const isMerchantOTPRequired = (
  form: MerchantProfileForm,
  initialFormValue: MerchantProfileForm
) => {
  const wasFieldChanged = MerchantOTPRequiredFields.map((field) => {
    return form[field] !== initialFormValue[field];
  });
  return wasFieldChanged.some(Boolean);
};

export const employeeFormHasError = (
  formErrors: EmployeeProfileFormValidation
) => {
  return Object.values(formErrors).some((error) => error.hasError);
};

export const hasEmployeeFormChanged = (
  formData: EmployeeProfileForm,
  defaultFormData: EmployeeProfileForm
) => {
  return Object.keys(formData).some((k) => {
    const key = k as keyof EmployeeProfileForm;
    return formData[key] !== defaultFormData[key];
  });
};

export const isEmployeeOTPRequired = (
  form: EmployeeProfileForm,
  initialFormValue: EmployeeProfileForm
) => {
  const wasFieldChanged = EmployeeOTPRequiredFields.map((field) => {
    return form[field] !== initialFormValue[field];
  });
  return wasFieldChanged.some(Boolean);
};
